import initLondLife from './components/london-life';
import initLondHello from './components/london-hello';
import initLondonMap from './components/london-map';

const londonLifeEl = document.querySelector('.js-london-life');

if (londonLifeEl) {
    initLondLife(londonLifeEl);
}

const londonHelloEl = document.querySelector('.js-hello-ticker');

if (londonHelloEl) {
    initLondHello(londonHelloEl);
}

const londonMapEl = document.querySelector('.js-london-map');

if (londonMapEl) {
    initLondonMap(londonMapEl);
}
